import moment from "moment/moment";
import isVehicleOlderThan from "../../../../context/utils/isVehicleOlderThan";

const fillAdvancedConfigByCompany = (companies, values, productCodesData, locationCodes, localidadOptions, polkoClientes) => {
    let advancedConfig = {};

    for (let company of companies) {
        const companyCodesObj = productCodesData.find(item => item.id_aseguradora === company) ?? "";
        const discount = companyCodesObj?.descuentos?.general ?? "";
        const discountFP = companyCodesObj?.descuentos?.fuera_pauta ?? "";
        switch (company) {
            case 1: //Sancor
                advancedConfig = {
                    ...advancedConfig,
                    "Sancor": {
                        ...(!polkoClientes && {
                            ...values.configuracionAvanzada.Sancor,
                            "tipoUso": "2",
                            "descuentoModelo": 99,
                            "codigos": companyCodesObj?.codigos,
                            "comision": companyCodesObj?.comisiones?.general ?? 0,
                            // "descuentoEspecial": discount > 0 ? (discount - 5) : discount
                            // This is a business rule now
                            "descuentoEspecial": discount,
                            "descuentoFueraPauta": discountFP,
                        }),
                        "codSancorLocalidad": `${locationCodes.CodigoLocalidadSancor}`,
                        "fechaCotizacion": values?.configuracionAvanzada?.Sancor?.fechaCotizacion
                    }
                }
                break;
            case 2: //RUS
                advancedConfig = {
                    ...advancedConfig,
                    "RUS": {
                        ...(!polkoClientes && {
                            ...values.configuracionAvanzada.RUS,
                            "codigos": companyCodesObj.codigos,
                            "comision": companyCodesObj.comisiones.general,
                            "descuentoEspecial": discount,
                        }),
                        "codRUSLocalidad": `${locationCodes.CodigoLocalidadRUS}`,
                        "vigenciaDesde": values?.configuracionAvanzada?.RUS?.vigenciaDesde,
                        "vigenciaHasta": values?.configuracionAvanzada?.RUS?.vigenciaHasta
                    }
                }
                break
            case 3: //Zurich
                advancedConfig = {
                    ...advancedConfig,
                    "Zurich": {
                        ...(!polkoClientes && {
                            ...values.configuracionAvanzada.Zurich,
                            "idViaCobro": '7',
                            "codigos": companyCodesObj.codigos,
                            "comision": companyCodesObj.comisiones.general,
                        }),
                        "codZurichLocalidad": `${locationCodes.CodigoLocalidadZurich}`,
                        "codProvincia": localidadOptions[0].idProvincia,
                        "vigenciaDesde": moment().format('YYYY-MM-DD'),
                        "vigenciaHasta": moment().add(1, "Y").format("YYYY-MM-DD"),
                        ...(values.vehiculo.ceroKm === "true"
                            ? {mesAnioFacturacion: moment().startOf('month').toISOString()}
                            : {}),
                    }
                }
                break;
            case 7: //Rivadavia
                advancedConfig = {
                    ...advancedConfig,
                    "Rivadavia": {
                        ...(!polkoClientes && {
                            ...values.configuracionAvanzada.Rivadavia,
                            "codigos": companyCodesObj.codigos,
                            "comision": companyCodesObj.comisiones.general,
                            "descuentoEspecial": discount,
                        }),
                        "codRivadaviaLocalidad": `${locationCodes.NombreLocalidadRivadavia}`,
                        "vigenciaDesde": values?.configuracionAvanzada?.Rivadavia?.vigenciaDesde,
                        "vigenciaHasta": values?.configuracionAvanzada?.Rivadavia?.vigenciaHasta,
                        grua: values.configuracionAvanzada.Rivadavia.grua ?? isVehicleOlderThan(values?.vehiculo?.anio ?? values?.motovehiculo?.anio, 15),
                    }
                }
                break;
            default:
                advancedConfig = {
                    ...advancedConfig
                }
                break;
        }
    }

    return advancedConfig;
}

export {fillAdvancedConfigByCompany};